<template>
    <section class="our-story-banner">
        <div class="container">
            <h2 class="our-story-banner__heading">Our Story</h2>

            <p class="body-copy body-copy--align-center our-story-banner__copy">
                Khonsu Brand Lab has been built by a team of creative IP specialists with a long history supporting
                marketing teams and industry.  We’ve seen the time it can take to create a new brand name. Using Khonsu
                Brand Lab will help you with that process.  Further, we’ve seen marketing teams spend money creating
                potential new brand names only to find they don’t make it across the finishing line because the IP has
                already been taken.  Khonsu Brand Lab gives you a solid preliminary view on whether your name has real
                potential!
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'OurStoryBanner',
    }
</script>